import React from 'react';
import PropTypes from 'prop-types';
import RaisedButton from 'material-ui/RaisedButton';
import TextField from 'material-ui/TextField';
import NumberFormat from 'react-number-format';
import AutoComplete from 'material-ui/AutoComplete';
import {
    GridList,
    GridTile,
} from 'material-ui/GridList';

import {
    Utils,
    apiService,
} from '../../services';

class InscricaoStepBoleto extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            bairroSelecionado: '',
            cidadeSelecionada: '',
            dsBairros: [],
            dsCidades: [],
            nome: '',
            dataNascimento: '',
            email: '',
            endereco: '',
            cpf: '',
        };

    //    this.state = {
    //        bairroSelecionado: '',
    //        cidadeSelecionada: '',
    //        dsBairros: [],
    //        dsCidades: [],
    //        nome: 'Claudio Scheer',
    //        dataNascimento: '29/05/1997',
    //        email: 'claudioscheer16@gmail.com',
    //        endereco: 'Rua Tal, 35',
    //        cpf: '03954555026',
    //    };
    }

    async onGetBairrosLogos(value) {
        const bairros = await apiService.getBairros(value);
        this.setState({ dsBairros: bairros });
    }

    async onGetCidadesLogos(value) {
        if (!value) {
            return;
        }
        const cidades = await apiService.getCidades(value, '-1');
        this.setState({ dsCidades: cidades });
    }

    async onPagarComBoleto(event) {
        event.preventDefault();
        const {
            nome,
            email,
            cpf,
            dataNascimento,
            endereco,
            bairroSelecionado,
            cidadeSelecionada,
        } = this.state;

        if (!Utils.isCPFValido(cpf)) {
            Utils.showToast('CPF é inválido.');
        } else if (!Utils.isDataValida(dataNascimento)) {
            Utils.showToast('Data de nascimento é inválida.');
        } else if (!Utils.isEmailValido(email)) {
            Utils.showToast('E-mail é inválido.');
        } else if (!bairroSelecionado) {
            Utils.showToast('Bairro não foi selecionado conforme opções da busca.');
        } else if (!cidadeSelecionada) {
            Utils.showToast('Cidade não foi selecionada conforme opções da busca.');
        } else {
            this.props.onPagarComBoleto(nome, email, cpf, dataNascimento, endereco, bairroSelecionado, cidadeSelecionada);
        }
    }

    async onSelectCidadeLogos(cidade) {
        this.setState({ cidadeSelecionada: cidade.LOG001 });
    }

    async onSelectBairroLogos(bairro) {
        this.setState({ bairroSelecionado: bairro.Codigo });
    }

    validarCPF(value) {
        if (!Utils.isCPFValido(value)) {
            this.setState({ cpfErrorText: 'CPF inválido', cpf: value });
            return false;
        }
        this.setState({ cpfErrorText: '', cpf: value });
        return true;
    }

    validarEmail(value) {
        if (!Utils.isEmailValido(value)) {
            this.setState({ emailErrorText: 'E-mail inválido', email: value });
            return false;
        }
        this.setState({ emailErrorText: '', email: value });
        return true;
    }

    render() {
        const {
            nome,
            cpf,
            email,
            cpfErrorText,
            emailErrorText,
            dataNascimento,
            endereco,
            dsBairros,
            dsCidades,
            bairroSelecionado,
            cidadeSelecionada,
        } = this.state;

        return (
            <div>
                <form onSubmit={event => this.onPagarComBoleto(event)}>
                    <br />
                    <h3>Informações pessoais para o boleto</h3>
                    <GridList cols={3} cellHeight="auto">
                        <GridTile cols={1.5}>
                            <TextField
                                floatingLabelText="Nome completo"
                                required
                                fullWidth
                                errorText={nome ? '' : 'Campo obrigatório'}
                                onChange={e => this.setState({ nome: e.target.value })}
                                value={nome}
                            />
                        </GridTile>
                        <GridTile cols={1.5}>
                            <TextField
                                floatingLabelText="E-mail"
                                type="email"
                                required
                                fullWidth
                                errorText={!email ? 'Campo obrigatório' : emailErrorText}
                                onChange={e => this.validarEmail(e.target.value)}
                                value={email}
                            />
                        </GridTile>
                        <GridTile cols={1.5}>
                            <TextField
                                floatingLabelText="Endereço"
                                required
                                fullWidth
                                errorText={endereco ? '' : 'Campo obrigatório'}
                                onChange={e => this.setState({ endereco: e.target.value })}
                                value={endereco}
                            />
                        </GridTile>
                        <GridTile cols={0.75}>
                            <NumberFormat
                                format="###.###.###-##"
                                customInput={TextField}
                                required
                                fullWidth
                                value={cpf}
                                errorText={!cpf ? 'Campo obrigatório' : cpfErrorText}
                                floatingLabelText="CPF"
                                onChange={e => this.validarCPF(e.target.value)}
                            />
                        </GridTile>
                        <GridTile cols={0.75}>
                            <NumberFormat
                                floatingLabelText="Data nascimento"
                                format="##/##/####"
                                customInput={TextField}
                                required
                                fullWidth
                                value={dataNascimento}
                                errorText={dataNascimento ? '' : 'Campo obrigatório'}
                                onChange={e => this.setState({ dataNascimento: e.target.value })}
                            />
                        </GridTile>
                        <GridTile cols={1.5}>
                            <AutoComplete
                                value={bairroSelecionado}
                                floatingLabelText="Bairro: digite e aguarde as opções para selecionar"
                                dataSource={dsBairros}
                                required
                                fullWidth
                                dataSourceConfig={{ text: 'Descricao', value: 'Codigo' }}
                                onUpdateInput={value => this.onGetBairrosLogos(value)}
                                onNewRequest={e => this.onSelectBairroLogos(e)}
                                filter={AutoComplete.noFilter}
                            />
                        </GridTile>
                        <GridTile cols={1.5}>
                            <AutoComplete
                                value={cidadeSelecionada}
                                floatingLabelText="Cidade: digite e aguarde as opções para selecionar"
                                dataSource={dsCidades}
                                required
                                fullWidth
                                dataSourceConfig={{ text: 'Descricao', value: 'LOG001' }}
                                onUpdateInput={value => this.onGetCidadesLogos(value)}
                                onNewRequest={e => this.onSelectCidadeLogos(e)}
                                filter={AutoComplete.noFilter}
                            />
                        </GridTile>
                    </GridList>

                    <RaisedButton
                        label="Gerar boleto"
                        primary
                        type="submit"
                    />
                </form>
            </div >
        );
    }
}

InscricaoStepBoleto.propTypes = {
    onPagarComBoleto: PropTypes.func.isRequired,
};

export default InscricaoStepBoleto;
